import React from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import "react-datepicker/dist/react-datepicker.css";

registerLocale("es", es);

const CustomDatePicker = ({ selected, onChange, ...props }) => {
    const handleRawChange = (e) => {
        // Verificamos que e y e.target existan para evitar el error de 'undefined'
        const inputValue = e?.target?.value;
        if (!inputValue) return;

        let val = inputValue.replace(/\D/g, ""); // Ahora es seguro usar replace

        if (val.length > 2 && val.length <= 4) {
            val = val.slice(0, 2) + "/" + val.slice(2);
        } else if (val.length > 4) {
            val = val.slice(0, 2) + "/" + val.slice(2, 4) + "/" + val.slice(4, 8);
        }

        e.target.value = val;
    };

    return (
        <DatePicker
            {...props}
            selected={selected}
            onChange={onChange}
            onChangeRaw={handleRawChange}
            locale="es"
            dateFormat="dd/MM/yyyy"
            onFocus={(e) => e.target.select()}
            placeholderText="DD/MM/AAAA"
            // Clases base por defecto, se pueden sobreescribir con props.className
            className={`border border-gray-300 rounded-lg px-3 py-2 text-sm outline-none transition-all
            focus:border-gray-500 focus:ring-1 focus:ring-gray-500
            ${props.className || ""}`}
                />
            );
};

export default CustomDatePicker;